export const leadershipData = {
  title: "GDG on Campus Pune District Education Association's College of Engineering - Pune, India",
  role: "Organizer [aka GDSC Lead]",
  description: "Leading a vibrant community dedicated to fostering innovation, collaboration, and skill development among students. As a chapter of Google's global student developer network, we provide a platform for aspiring developers, designers, and tech enthusiasts to explore emerging technologies, build impactful projects, and engage with like-minded peers.",
  stats: [
    { label: "Events Organized", value: "5+" },
    { label: "Community Members", value: "268+" },
    { label: "Workshops Conducted", value: "30+" }
  ],
  events: [
    {
        id: 1,
        title: "Team",
        imageUrl: "https://res.cloudinary.com/startup-grind/image/upload/c_fill,dpr_2,f_auto,g_center,h_540,q_auto:good,w_720/v1/gcs/platform-data-goog/chapter_photos/Screenshot%25202024-09-20%2520190819_I08PKE8.png",
        size: "wide"
        },
    {
      id: 2,
      title: "Tech Winter Break",
      imageUrl: "https://res.cloudinary.com/startup-grind/image/upload/c_fill,dpr_2,f_auto,g_center,h_200,q_auto:good,w_200/v1/gcs/platform-data-goog/chapter_photos/WhatsApp%2520Image%25202024-09-21%2520at%252022.40.55_6024eef8_oGif0bF.jpg",
      size: "small"
    },
    {
      id: 3,
      title: "Build On Aptos BootCamp",
      imageUrl: "https://res.cloudinary.com/startup-grind/image/upload/c_fill,dpr_2,f_auto,g_center,h_200,q_auto:good,w_200/v1/gcs/platform-data-goog/chapter_photos/WhatsApp%2520Image%25202024-12-31%2520at%252011.50.36_d699fc80_QJODpYa.jpg",
      size: "small"
    },
    {
      id: 4,
      title: "Solution Challenge",
      imageUrl: "https://res.cloudinary.com/startup-grind/image/upload/c_fill,dpr_2,f_auto,g_center,h_200,q_auto:good,w_200/v1/gcs/platform-data-goog/chapter_photos/WhatsApp%2520Image%25202024-12-31%2520at%252011.52.51_7d89e96c_BWSSsys.jpg",
      size: "small"
    },
    {
        id: 5,
        title: "Gen Ai Study Jam",
        imageUrl: "https://res.cloudinary.com/startup-grind/image/upload/c_fill,dpr_2,f_auto,g_center,h_200,q_auto:good,w_200/v1/gcs/platform-data-goog/chapter_photos/WhatsApp%2520Image%25202024-09-21%2520at%252022.39.27_3eae7c33_20RQgqL.jpg", // Replace with actual image URLs
        size: "small"
      },
    
  ]
};
